import { Controller } from 'react-hook-form';
import type { Control } from 'react-hook-form';

import { FormHelperText, ToggleButtonGroup } from '@mui/material';
import type { ToggleButtonGroupProps } from '@mui/material';
import {
  StyledToggleButton,
  StyledToggleButtonFormControl,
  StyledToggleButtonFormLabel
} from './ControlledToggleButtonGroup.styled';

interface Props extends ToggleButtonGroupProps {
  control: Control<any>;
  name: string;
  label?: string;
  inputToggleButtons: {
    label: string;
    value: string | number | boolean;
    selected?: boolean;
    disabled?: boolean;
  }[];
  direction?: 'row' | 'column';
}

export default function ControlledToggleButtonGroup({
  control,
  name,
  label,
  color = 'standard',
  inputToggleButtons,
  direction = 'column',
  ...toggleButtonGroupProps
}: Props) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <StyledToggleButtonFormControl
          error={!!fieldState.error}
          direction={direction}
        >
          {label && (
            <StyledToggleButtonFormLabel>{label}</StyledToggleButtonFormLabel>
          )}
          <ToggleButtonGroup
            exclusive
            size="small"
            color={color}
            value={field.value}
            onChange={(_, value) => field.onChange(value)} // important!
            {...toggleButtonGroupProps}
          >
            {(inputToggleButtons || []).map(
              ({ label, value, selected, disabled }, i: number) => (
                <StyledToggleButton
                  key={i}
                  size="small"
                  value={value}
                  aria-label="left aligned"
                  selected={selected}
                  disabled={disabled}
                >
                  {label}
                </StyledToggleButton>
              )
            )}
          </ToggleButtonGroup>

          {fieldState?.error?.message && (
            <FormHelperText sx={{ ml: 0 }}>
              {fieldState.error.message}
            </FormHelperText>
          )}
        </StyledToggleButtonFormControl>
      )}
    />
  );
}
